import React, { useId, useState, useMemo } from 'react';
import cn from 'classnames';
import * as Checkbox from '@radix-ui/react-checkbox';

import TickIcon from '@assets/icons/Tick.svg';

import Button from '@components/Button';

import * as styles from './CheckboxList.module.css';
import * as textStyles from '@styles/textStyles.module.css';

const CheckboxItem = ({ label, name, value, onChange }) => {
  const id = useId();

  return (
    <div className={styles.checkboxItem}>
      <Checkbox.Root
        id={id}
        name={name}
        className={styles.checkbox}
        checked={!!value}
        onCheckedChange={(checked) => onChange(name, checked)}
      >
        <Checkbox.Indicator className={styles.checkboxIndicator}>
          <TickIcon className={styles.checkboxIcon} />
        </Checkbox.Indicator>
      </Checkbox.Root>
      <label className={styles.checkboxLabel} htmlFor={id}>
        {label}
      </label>
    </div>
  );
};

const DEFAULT_SHOW_LIMIT = 10;

const CheckboxList = ({ label, items, onChange }) => {
  const [showAll, setShowAll] = useState(false);

  const itemsToShow = useMemo(() => {
    if (showAll) return items;
    return items.slice(0, DEFAULT_SHOW_LIMIT);
  }, [items, showAll]);

  const notShowing = items.length - DEFAULT_SHOW_LIMIT;

  return (
    <div className={styles.root}>
      <h3 className={cn(textStyles.eyebrow, styles.title)}>{label}</h3>
      <ul className={styles.list}>
        {itemsToShow.map(({ label, value }) => (
          <li key={label}>
            <CheckboxItem
              label={label}
              name={label}
              value={value}
              onChange={onChange}
            />
          </li>
        ))}
        {!showAll && items.length > DEFAULT_SHOW_LIMIT && (
          <li className={styles.showMore}>
            <Button
              size="small"
              variant="link"
              onClick={() => setShowAll(true)}
            >
              Show {notShowing} more
            </Button>
          </li>
        )}
      </ul>
    </div>
  );
};

export default CheckboxList;
